// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.5rem;
    margin-left:auto;
}

.pagination__wrapper {
    padding: 1rem;
    width: 100%;
}

.pagination__button {
    padding: 0.5rem 0.8rem;
    border: 1px solid #ccc;
    background-color: white;
    cursor: pointer;
    transition: background-color 0.3s, border-color 0.3s;
}

.pagination__button--prev,
.pagination__button--next {
    font-weight: bold;
}

.pagination__button--page {
    border-radius: 4px;
}

.pagination__button--active, .pagination__button:not(:disabled):hover  {
    background-color: var(--accent1);
    border-color: var(--acent3);
    color: white;
}

.pagination__button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/shop-pagination/shop-pagination.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,oDAAoD;AACxD;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".pagination {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 0.5rem;\n    margin-left:auto;\n}\n\n.pagination__wrapper {\n    padding: 1rem;\n    width: 100%;\n}\n\n.pagination__button {\n    padding: 0.5rem 0.8rem;\n    border: 1px solid #ccc;\n    background-color: white;\n    cursor: pointer;\n    transition: background-color 0.3s, border-color 0.3s;\n}\n\n.pagination__button--prev,\n.pagination__button--next {\n    font-weight: bold;\n}\n\n.pagination__button--page {\n    border-radius: 4px;\n}\n\n.pagination__button--active, .pagination__button:not(:disabled):hover  {\n    background-color: var(--accent1);\n    border-color: var(--acent3);\n    color: white;\n}\n\n.pagination__button:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
